import { Observable } from 'rxjs';
import { NgControl } from '@angular/forms';

export abstract class PgFieldControl<T> {
  value: T | null;

  // Used to notify listeners when the form field state has changed
  readonly stateChanges: Observable<void>;

  // the placeholder for this control
  readonly placeholder: string;

  // the ngControl for this control
  readonly ngControl: NgControl | null;

  readonly isFocused: boolean;

  readonly isEmpty: boolean;

  readonly isError: boolean;

  /**
   * An optional name for the control type that can be used to distinguish `pg-form-field` elements
   * based on their control type. The form field will add a class,
   * `pg-form-field-type-{{controlType}}` to its root element.
   */
  readonly controlType?: string;

  readonly shouldLabelFloat: boolean;

  readonly isDisabled: boolean;

  readonly isAutofilled: boolean;

  blur: Function;

  focus: Function;

  isErrorStateFrozen: boolean;

  readonly id: string;

  abstract onContainerClick();
}
